"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findOurTakeHighlightContent = void 0;

require("core-js/modules/es6.regexp.constructor.js");

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.string.starts-with.js");

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _constants = require("../constants");

var removeBannerTextFromContent = function removeBannerTextFromContent(bullet, textToRemove) {
  var regex = new RegExp("^".concat(textToRemove, "[!:\\- ]+"), 'gi');
  return bullet.replace(regex, '');
};

var findOurTakeHighlightContent = function findOurTakeHighlightContent(marketingBullets) {
  if (!(0, _isEmpty2.default)(marketingBullets)) {
    var matchingBullets = marketingBullets.filter(function (bullet) {
      var bulletLower = bullet.toLowerCase();
      return bulletLower.startsWith(_constants.SEARCH_TEXT.NEW) || bulletLower.startsWith(_constants.SEARCH_TEXT.LIMITED) || bulletLower.startsWith(_constants.SEARCH_TEXT.NERDWALLET);
    }).map(function (bullet) {
      var bulletLower = bullet.toLowerCase();

      if (bulletLower.startsWith(_constants.SEARCH_TEXT.NEW)) {
        return {
          type: 'NEW',
          content: removeBannerTextFromContent(bullet, _constants.SEARCH_TEXT.NEW)
        };
      }

      if (bulletLower.startsWith(_constants.SEARCH_TEXT.LIMITED)) {
        return {
          type: 'LIMITED',
          content: removeBannerTextFromContent(bullet, _constants.SEARCH_TEXT.LIMITED)
        };
      }

      return {
        type: 'NERDWALLET',
        content: removeBannerTextFromContent(bullet, _constants.SEARCH_TEXT.NERDWALLET)
      };
    });
    return matchingBullets[0] || null;
  }

  return null;
};

exports.findOurTakeHighlightContent = findOurTakeHighlightContent;